// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Tracking_Event from "../Restaumatic.Analytics.Tracking.Event/index.js";
var emptyEvent = function (name) {
    return new Data_Maybe.Just({
        name: name,
        value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil))({})
    });
};
var toPlatformEvent = function (currency) {
    return function (v) {
        if (v instanceof Restaumatic_Analytics_Tracking_Event.AddToCart) {
            return emptyEvent("AddToCart");
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.LocateMe) {
            return emptyEvent("LocateMe");
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.RemoveFromCart) {
            return emptyEvent("RemoveFromCart");
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.BeginCheckout) {
            return emptyEvent("BeginCheckout");
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.SetCheckoutOption) {
            return emptyEvent("SetCheckoutOption");
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.Purchase) {
            var mkTransaction = {
                id: v.value0.transactionId,
                affiliation: v.value0.affiliation,
                revenue: Data_Money_Rounded.toNumber(v.value0.total),
                shipping: Data_Money_Rounded.toNumber(v.value0.shipping),
                tax: 0.0,
                currency: currency
            };
            var mkItem = function (v1) {
                return {
                    id: v.value0.transactionId,
                    name: v1.name,
                    price: Data_Money_Rounded.toNumber(v1.price),
                    quantity: v1.quantity,
                    category: v1.category,
                    currency: currency
                };
            };
            return new Data_Maybe.Just({
                name: "Purchase",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "transaction";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "tax";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "shipping";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "revenue";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "affiliation";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))({
                    reflectSymbol: function () {
                        return "items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "price";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "name";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "category";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))))({
                    transaction: mkTransaction,
                    items: Data_Functor.map(Data_Functor.functorArray)(mkItem)(v.value0.items)
                })
            });
        };
        throw new Error("Failed pattern match at Utils.Tracking.AnalyticsV3 (line 33, column 28 - line 63, column 107): " + [ v.constructor.name ]);
    };
};
export {
    emptyEvent,
    toPlatformEvent
};
//# sourceMappingURL=index.js.map
